module["exports"] = {
  wide: [
    "Կիրակի",
    "Երկուշաբթի",
    "Երեքշաբթի",
    "Չորեքշաբթի",
    "Հինգշաբթի",
    "Ուրբաթ",
    "Շաբաթ"
  ],

  abbr: [
    "կրկ",
    "երկ",
    "երք",
    "չրք",
    "հնգ",
    "ուրբ",
    "շբթ"
  ],
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/hy/date/weekday.js
// module id = 3073
// module chunks = 1610